import React from 'react'
import AppBar from '../components/AppBar';
import Footer from '../components/Footer';

function NoPage() {
  return (
    <div>
      <AppBar/>
        im sorry im too tired to fix fr
      <div className = 'flex-grow'> 
        <Footer/>
      </div>
    </div>
  )
}

export default NoPage
